import { createGlobalStyle, css } from 'styled-components';
import reset from 'styled-reset';
import '../defines/font.css';
export const palette = {
  avnfrMain: '#87000E',
  // Main
  main50: '#F2F3F3',
  main100: '#E5E8E7',
  main200: '#CBD1CF',
  main300: '#B2BAB7',
  main400: '#98A39F',
  main500: '#7E8C88',
  main600: '#657570',
  main700: '#4B5E58',
  main800: '#314740',
  main900: '#183029', // MAIN
  main950: '#0C1814',
  mainVariant: '#537C70',

  mainAvnfr: '#85121E',
  mainAvnfrHover: '#660E15',

  // Secondary
  secondary50: '#F3F1EE',
  secondary300: '#BCAC9B',
  secondary500: '#907559',
  secondary700: '#564635',

  secondaryRed700: '#85121E',

  // Neutral
  neutral50: '#F2F3F3',
  neutral100: '#E5E6E6',
  neutral200: '#CBCCCC',
  neutral300: '#B2B3B3',
  neutral400: '#989999',
  neutral500: '#7F7F7F',
  neutral600: '#656666',
  neutral700: '#4C4C4C',
  neutral800: '#323333',
  neutral900: '#191919',
  neutral950: '#0C0C0C',

  //primary
  appMain: '#CC1427',
  primaryBlack950: '#1A1A1A',
  primaryRed500: '#DF1E32',
  // etc.
  white: '#FFFFFF',
  black: '#000000',
  opacityWhite80: 'rgba(255, 255, 255, 0.8)',
  opacityBlack40: 'rgba(0, 0, 0, 0.4)',
  opacityBlack80: 'rgba(0, 0, 0, 0.8)',
  bgOverlay1: 'rgba(0, 0, 0, 0.5)',
  bgOverlay2: 'rgba(0, 0, 0, 0.8)',
  bgOverlay3: 'rgba(255, 255, 255, 0.8)',

  // system
  systemRed: '#D22D2D',
  systemYellow: '#F99E20',
  systemGreen: '#45A149',
  systemBlue: '#0077CC',
  systemGray: '#CCCCCC',

  // Faview

  sigColor: 'rgba(0, 151, 255, 1)',
  gray30: 'rgba(30, 30, 30, 1)',
  gray50: '#f2f2f4',
  gray100: '#E5E5EA',
  gray300: '#B2B2B6',
  gray500: '#7F7F82',
  gray700: '#4C4C4E',
  gray57: 'rgba(57, 57, 57, 1)',
  gray151: 'rgba(151, 151, 151, 1)',
  xrParkingUnselected: 'rgba(193, 192, 201, 1)',
  xrParkingPillar: 'rgba(26, 69, 109, 1)',
  xrParkingArea: 'rgba(255, 255, 255, 0.3)',
  xrTransportable: 'rgba(57, 53, 51, 1)',
  xrParkingCar: 'rgba(233, 77, 93, 1)',
  xrParkingHyundai: 'rgba(36, 78, 68, 1)',
  xrHoban: '#183029',
};

export const font = {
  heading: {
    h1: {
      size: '2.25rem',
      lineHeight: '2.75rem',
      weight: 700, // Bold
    },
    h2: {
      size: '1.5rem',
      lineHeight: '2rem',
      weight: 700, // Bold
    },
    h3: {
      size: '1.25rem',
      lineHeight: '1.75rem',
      weight: 700, // Bold
    },
    h4: {
      size: '1.125rem',
      lineHeight: '1.75rem',
      weight: 700, // Bold
    },
    h5: {
      size: '1rem',
      lineHeight: '1.5rem',
      weight: 700, // Bolda
    },
  },
  subtitle: {
    t1: {
      size: '2.25rem',
      lineHeight: '2.75rem',
      weight: 500, // Medium
    },
    t2: {
      size: '1.75rem',
      lineHeight: '2.25rem',
      weight: 500, // Medium
    },
    t3: {
      size: '1.5rem',
      lineHeight: '2rem',
      weight: 500, // Medium
    },
    t4: {
      size: '1.25rem',
      lineHeight: '1.75rem',
      weight: 500, // Medium
    },
    t5: {
      size: '1rem',
      lineHeight: '1.5rem',
      weight: 500, // Medium
    },
    t6: {
      size: '0.875rem',
      lineHeight: '1.25rem',
      weight: 500, // Medium
    },
  },
  text: {
    body1: {
      size: '2.25rem',
      lineHeight: '2.75rem',
      weight: 400, // Regular
    },
    body2: {
      size: '1.75rem',
      lineHeight: '2.25rem',
      weight: 400, // Regular
    },
    body3: {
      size: '1.5rem',
      lineHeight: '2rem',
      weight: 400, // Regular
    },
    body4: {
      size: '1.25rem',
      lineHeight: '1.75rem',
      weight: 400, // Regular
    },
    body5: {
      size: '1rem',
      lineHeight: '1.5rem',
      weight: 400, // Regular
    },
    body6: {
      size: '0.875rem',
      lineHeight: '1.25rem',
      weight: 400, // Regular
    },
  },
  caption: {
    caption1: {
      size: '0.75rem',
      lineHeight: '1rem',
      weight: 400, // Regular
    },
  },
};

const h1 = css`
  font-size: 2rem;
  font-weight: 700;
  line-height: 2.625rem; /* 131.25% */
  letter-spacing: -0.04rem;
`;

const h2 = css`
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 2rem; /* 133.333% */
  letter-spacing: -0.03rem;
`;
const h3 = css`
  font-size: 1.25rem;
  font-weight: 700;
  line-height: 1.75rem;
  letter-spacing: -0.025rem;
`;

const h4 = css`
  font-size: ${(props) => props.theme.font.heading.h4.size};
  font-weight: ${(props) => props.theme.font.heading.h4.weight};
  line-height: ${(props) => props.theme.font.heading.h4.lineHeight};
`;
const t5 = css`
  font-size: 1rem;
  font-weight: 500;
  line-height: 1.5rem;
`;

const body1 = css`
  font-size: 1.125rem;
  font-weight: 500;
  line-height: 1.625rem; /* 144.444% */
  letter-spacing: -0.0225rem;
`;
const body2 = css`
  font-size: 1rem;
  font-weight: 500;
  line-height: 1.5rem; /* 150% */
  letter-spacing: -0.02rem;
`;

const body3 = css`
  font-size: 0.875rem;
  font-weight: 700;
  line-height: 1.375rem; /* 157.143% */
  letter-spacing: -0.0175rem;
`;

const body4 = css`
  font-size: ${(props) => props.theme.font.text.body4.size};
  font-weight: ${(props) => props.theme.font.text.body4.weight};
  line-height: ${(props) => props.theme.font.text.body4.lineHeight};
`;

const body5 = css`
  font-size: ${(props) => props.theme.font.text.body5.size};
  font-weight: ${(props) => props.theme.font.text.body5.weight};
  line-height: ${(props) => props.theme.font.text.body5.lineHeight};
`;

const body6 = css`
  font-size: ${(props) => props.theme.font.text.body6.size};
  font-weight: ${(props) => props.theme.font.text.body6.weight};
  line-height: ${(props) => props.theme.font.text.body6.lineHeight};
`;
const GlobalStyles = createGlobalStyle`
  ${reset};


  * { 
    font-family: "Pretendard";
    touch-action: manipulation;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-smooth: never;
    margin: 0;
    padding: 0;
    box-sizing: border-box;

    &::-webkit-scrollbar {
      display: none;
    }
  
  }
  html, body {
    font-family: "Pretendard";
    font-size: clamp(12px, 3.74vw, 16px);
    height: 100%;
    overflow-x: auto;
    overflow: hidden;


 
  }
  button {
    border: none;
    background: none;
    padding: 0;
    cursor: pointer;
  }
`;

export { body1, body2, body3, body4, body5, body6, h1, h2, h3, h4, t5 };
export default GlobalStyles;
